const editorsChoiceCollection = [
  {
    adult: false,
    backdrop_path: "/o5zvZFVlAsHjv2yXaCMc6AySP7b.jpg",
    belongs_to_collection: null,
    budget: 68000000,
    genres: [
      {
        id: 27,
        name: "Horror",
      },
      {
        id: 9648,
        name: "Mystery",
      },
      {
        id: 878,
        name: "Science Fiction",
      },
    ],
    homepage: "https://www.nope.movie",
    id: 762504,
    imdb_id: "tt10954984",
    origin_country: ["US"],
    original_language: "en",
    original_title: "Nope",
    overview:
      "Residents in a lonely gulch of inland California bear witness to an uncanny, chilling discovery.",
    popularity: 50.415,
    poster_path: "/AcKVlWaNVVVFQwro3nLXqPljcYA.jpg",
    production_companies: [
      {
        id: 88934,
        logo_path: "/5Be96V9WXa7jJInSDPqDOqMBA0o.png",
        name: "Monkeypaw Productions",
        origin_country: "US",
      },
      {
        id: 33,
        logo_path: "/8lvHyhjr8oUKOOy2dKXoALWKdp0.png",
        name: "Universal Pictures",
        origin_country: "US",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "US",
        name: "United States of America",
      },
    ],
    release_date: "2022-07-20",
    revenue: 170823080,
    runtime: 130,
    spoken_languages: [
      {
        english_name: "English",
        iso_639_1: "en",
        name: "English",
      },
      {
        english_name: "Portuguese",
        iso_639_1: "pt",
        name: "Português",
      },
      {
        english_name: "Spanish",
        iso_639_1: "es",
        name: "Español",
      },
    ],
    status: "Released",
    tagline: "What’s a bad miracle?",
    title: "Nope",
    video: false,
    vote_average: 6.8,
    vote_count: 4054,
  },
  {
    adult: false,
    backdrop_path: "/ss0Os3uWJfQAENILHZUdX8Tt1OC.jpg",
    belongs_to_collection: null,
    budget: 25000000,
    genres: [
      {
        id: 28,
        name: "Action",
      },
      {
        id: 12,
        name: "Adventure",
      },
      {
        id: 878,
        name: "Science Fiction",
      },
    ],
    homepage: "https://a24films.com/films/everything-everywhere-all-at-once",
    id: 545611,
    imdb_id: "tt6710474",
    origin_country: ["US"],
    original_language: "en",
    original_title: "Everything Everywhere All at Once",
    overview:
      "An aging Chinese immigrant is swept up in an insane adventure, where she alone can save what's important to her by connecting with the lives she could have led in other universes.",
    popularity: 60.545,
    poster_path: "/rKvCys0fMIIi1X9rmJBxTPLAtoU.jpg",
    production_companies: [
      {
        id: 93105,
        logo_path: "/asuzX794BM1gCettTxUoLxGNovd.png",
        name: "IAC Films",
        origin_country: "US",
      },
      {
        id: 106544,
        logo_path: "/psd84iF7PTGrKf4yFOStKj8JbAh.png",
        name: "AGBO",
        origin_country: "US",
      },
      {
        id: 114130,
        logo_path: "/4qWbeq1VqAH1RSCBFvCNkkY5Qi8.png",
        name: "Ley Line Entertainment",
        origin_country: "US",
      },
      {
        id: 161506,
        logo_path: null,
        name: "Year of the Rat",
        origin_country: "US",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "US",
        name: "United States of America",
      },
    ],
    release_date: "2022-03-24",
    revenue: 139200000,
    runtime: 140,
    spoken_languages: [
      {
        english_name: "Cantonese",
        iso_639_1: "cn",
        name: "广州话 / 廣州話",
      },
      {
        english_name: "Mandarin",
        iso_639_1: "zh",
        name: "普通话",
      },
      {
        english_name: "English",
        iso_639_1: "en",
        name: "English",
      },
    ],
    status: "Released",
    tagline: "The universe is so much bigger than you realize.",
    title: "Everything Everywhere All at Once",
    video: false,
    vote_average: 7.78,
    vote_count: 6463,
  },
  {
    adult: false,
    backdrop_path: "/7h6TqPB3ESmjuVbxCxAeB1c9OB1.jpg",
    belongs_to_collection: null,
    budget: 17500000,
    genres: [
      {
        id: 27,
        name: "Horror",
      },
      {
        id: 18,
        name: "Drama",
      },
      {
        id: 878,
        name: "Science Fiction",
      },
    ],
    homepage:
      "https://www.the-match-factory.com/catalogue/films/the-substance.html",
    id: 933260,
    imdb_id: "tt17526714",
    origin_country: ["GB"],
    original_language: "en",
    original_title: "The Substance",
    overview:
      "A fading celebrity decides to use a black market drug, a cell-replicating substance that temporarily creates a younger, better version of herself.",
    popularity: 2814.996,
    poster_path: "/zQc1PITqFxZDbEmHlQgO5Mxc4Od.jpg",
    production_companies: [
      {
        id: 10163,
        logo_path: "/16KWBMmfPX0aJzDExDrPxSLj0Pg.png",
        name: "Working Title Films",
        origin_country: "GB",
      },
      {
        id: 233939,
        logo_path: null,
        name: "Blacksmith",
        origin_country: "FR",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "FR",
        name: "France",
      },
      {
        iso_3166_1: "GB",
        name: "United Kingdom",
      },
    ],
    release_date: "2024-09-07",
    revenue: 29106531,
    runtime: 141,
    spoken_languages: [
      {
        english_name: "English",
        iso_639_1: "en",
        name: "English",
      },
    ],
    status: "Released",
    tagline: "If you follow the instructions, what could go wrong?",
    title: "The Substance",
    video: false,
    vote_average: 7.3,
    vote_count: 915,
  },
  {
    adult: false,
    backdrop_path: "/mwdt9HsCddye6xzNvccPenaenjW.jpg",
    belongs_to_collection: null,
    budget: 5300000,
    genres: [
      {
        id: 16,
        name: "Animation",
      },
      {
        id: 18,
        name: "Drama",
      },
      {
        id: 35,
        name: "Comedy",
      },
      {
        id: 878,
        name: "Science Fiction",
      },
    ],
    homepage: "https://neonrated.com/films/robot-dreams",
    id: 838240,
    imdb_id: "tt13429870",
    origin_country: ["ES"],
    original_language: "es",
    original_title: "Robot Dreams",
    overview:
      "A lonely dog's friendship with his robot companion takes a sad turn when an unexpected malfunction forces him to abandon Robot at the beach. Will Dog ever meet Robot again?",
    popularity: 89.946,
    poster_path: "/ds402Qq09ybgBcXKiQNTZfzsP5o.jpg",
    production_companies: [
      {
        id: 7543,
        logo_path: "/sPBVpVQf44rVP65TVTFgsn9ZVwE.png",
        name: "Arcadia Motion Pictures",
        origin_country: "ES",
      },
      {
        id: 219048,
        logo_path: "/wFMVuHeLhu6ERbz7hkkPXJ5IVRX.png",
        name: "LokizFilms",
        origin_country: "ES",
      },
      {
        id: 7792,
        logo_path: "/ik1JWvnBmVY6Rrw8iQWB2cPuuf.png",
        name: "Noodles Production",
        origin_country: "FR",
      },
      {
        id: 7395,
        logo_path: "/cGOGYYfbJZ1uJHynRIf8yj4phRn.png",
        name: "Les films du Worso",
        origin_country: "FR",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "FR",
        name: "France",
      },
      {
        iso_3166_1: "ES",
        name: "Spain",
      },
    ],
    release_date: "2023-12-06",
    revenue: 4656348,
    runtime: 102,
    spoken_languages: [
      {
        english_name: "No Language",
        iso_639_1: "xx",
        name: "No Language",
      },
    ],
    status: "Released",
    tagline: "",
    title: "Robot Dreams",
    video: false,
    vote_average: 8.1,
    vote_count: 525,
  },
  {
    adult: false,
    backdrop_path: "/jhM3wgWUrrOkz9r4xwV5cV5RhI4.jpg",
    belongs_to_collection: null,
    budget: 30000000,
    genres: [
      {
        id: 878,
        name: "Science Fiction",
      },
    ],
    homepage: "http://www.d-9.com/",
    id: 17654,
    imdb_id: "tt1136608",
    origin_country: ["US"],
    original_language: "en",
    original_title: "District 9",
    overview:
      "Thirty years ago, aliens arrive on Earth. Not to conquer or give aid, but to find refuge from their dying planet. Separated from humans in a South African area called District 9, the aliens are managed by Multi-National United, which is unconcerned with the aliens' welfare but will do anything to master their advanced technology. When a company field agent contracts a mysterious virus that begins to alter his DNA, there is only one place he can hide: District 9.",
    popularity: 37.973,
    poster_path: "/tuGlQkqLxnodDSk6mp5c2wvxUEd.jpg",
    production_companies: [
      {
        id: 559,
        logo_path: "/eC0bWHVjnjUducyA6YFoEFqnPMC.png",
        name: "TriStar Pictures",
        origin_country: "US",
      },
      {
        id: 8504,
        logo_path: null,
        name: "Block / Hanson",
        origin_country: "US",
      },
      {
        id: 11,
        logo_path: "/6FAuASQHybRkZUk08p9PzSs9ezM.png",
        name: "WingNut Films",
        origin_country: "NZ",
      },
      {
        id: 20667,
        logo_path: null,
        name: "District 9",
        origin_country: "",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "NZ",
        name: "New Zealand",
      },
      {
        iso_3166_1: "ZA",
        name: "South Africa",
      },
      {
        iso_3166_1: "US",
        name: "United States of America",
      },
    ],
    release_date: "2009-08-05",
    revenue: 210888950,
    runtime: 112,
    spoken_languages: [
      {
        english_name: "Afrikaans",
        iso_639_1: "af",
        name: "Afrikaans",
      },
      {
        english_name: "Chichewa; Nyanja",
        iso_639_1: "ny",
        name: "",
      },
      {
        english_name: "Sotho",
        iso_639_1: "st",
        name: "",
      },
      {
        english_name: "Xhosa",
        iso_639_1: "xh",
        name: "",
      },
      {
        english_name: "Zulu",
        iso_639_1: "zu",
        name: "isiZulu",
      },
      {
        english_name: "English",
        iso_639_1: "en",
        name: "English",
      },
    ],
    status: "Released",
    tagline: "You are not welcome here.",
    title: "District 9",
    video: false,
    vote_average: 7.447,
    vote_count: 9382,
  },
  {
    adult: false,
    backdrop_path: "/5l3Xb2WQR0nXiVhbj5rAv0z4xsZ.jpg",
    belongs_to_collection: null,
    budget: 12000000,
    genres: [
      {
        id: 12,
        name: "Adventure",
      },
      {
        id: 18,
        name: "Drama",
      },
    ],
    homepage: "",
    id: 62204,
    imdb_id: "tt0082484",
    origin_country: ["CA", "FR"],
    original_language: "fr",
    original_title: "La Guerre du feu",
    overview:
      "In the prehistoric world, a Cro-Magnon tribe depends on an ever-burning source of fire, which eventually extinguishes. Lacking the knowledge to start a new fire, the tribe sends three warriors on a quest for more. With the tribe's future at stake, the warriors make their way across a treacherous landscape full of hostile tribes and monstrous beasts. On their journey, they encounter Ika, a woman who has the knowledge they seek.",
    popularity: 15.365,
    poster_path: "/tyzW1M00xfHKNtmTlT6wJ3F4pNr.jpg",
    production_companies: [
      {
        id: 999,
        logo_path: null,
        name: "Belstar Productions",
        origin_country: "",
      },
      {
        id: 2359,
        logo_path: null,
        name: "Stéphan Films",
        origin_country: "FR",
      },
      {
        id: 25765,
        logo_path: null,
        name: "International Cinema Corporation (ICC)",
        origin_country: "CA",
      },
      {
        id: 111483,
        logo_path: null,
        name: "Ciné Trail",
        origin_country: "",
      },
      {
        id: 111484,
        logo_path: null,
        name: "Gruskoff Film Organization",
        origin_country: "",
      },
      {
        id: 111485,
        logo_path: null,
        name: "Royal Bank of Canada",
        origin_country: "",
      },
      {
        id: 16914,
        logo_path: null,
        name: "Famous Players Limited",
        origin_country: "",
      },
      {
        id: 25,
        logo_path: "/qZCc1lty5FzX30aOCVRBLzaVmcp.png",
        name: "20th Century Fox",
        origin_country: "US",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "CA",
        name: "Canada",
      },
      {
        iso_3166_1: "FR",
        name: "France",
      },
    ],
    release_date: "1981-12-16",
    revenue: 55260558,
    runtime: 100,
    spoken_languages: [
      {
        english_name: "No Language",
        iso_639_1: "xx",
        name: "No Language",
      },
    ],
    status: "Released",
    tagline: "A Science Fantasy Adventure",
    title: "Quest for Fire",
    video: false,
    vote_average: 7.1,
    vote_count: 497,
  },
  {
    adult: false,
    backdrop_path: "/oslUsPw3PUhDVK7a5soTvCAuaO7.jpg",
    belongs_to_collection: {
      id: 668003,
      name: "One Cut of the Dead Collection",
      poster_path: "/ofjhUDJC8d73JDC0melaOS5K7pS.jpg",
      backdrop_path: "/rHIWhW9zI87ktQfxbYwvMFSwUpB.jpg",
    },
    budget: 52406,
    genres: [
      {
        id: 35,
        name: "Comedy",
      },
      {
        id: 27,
        name: "Horror",
      },
    ],
    homepage: "https://intl.nikkatsu.com/sales/310.html",
    id: 513434,
    imdb_id: "tt7914416",
    origin_country: ["JP"],
    original_language: "ja",
    original_title: "カメラを止めるな！",
    overview:
      "Real zombies arrive and terrorize the crew of a zombie film being shot in an abandoned warehouse, said to be the site of military experiments on humans.",
    popularity: 20.871,
    poster_path: "/rws34k2bqYVo2B5MkhKAbV8925j.jpg",
    production_companies: [
      {
        id: 103655,
        logo_path: null,
        name: "Panpokopina",
        origin_country: "JP",
      },
      {
        id: 103894,
        logo_path: null,
        name: "ENBU Seminar",
        origin_country: "",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "JP",
        name: "Japan",
      },
    ],
    release_date: "2017-11-04",
    revenue: 27590180,
    runtime: 96,
    spoken_languages: [
      {
        english_name: "Japanese",
        iso_639_1: "ja",
        name: "日本語",
      },
    ],
    status: "Released",
    tagline: "Don't Stop Shooting!",
    title: "One Cut of the Dead",
    video: false,
    vote_average: 7.6,
    vote_count: 820,
  },
];

export default editorsChoiceCollection;
